export default __webpack_public_path__ + "static/article-finance-big-financial-32541c941be10ef3e30943e8c0fe719f.jpg";